import request from '@/router/axios'

//查询素材库列表
export function queryList(query) {
	return request({
		url: '/dist/material/page',
		method: 'get',
		params: query,
	})
}

//获取我的二维码
export function getQrcode(query) {
	return request({
		url: '/dist/material/getQrcode',
		method: 'get',
		params: query,
	})
}

//上传我的二维码
export function uploadQrcode(obj) {
	return request({
		url: '/dist/material/save/qrcode',
		method: 'post',
		data: obj,
	})
}

//下载素材
export function downMaterial(obj) {
	return request({
		url: '/dist/material/download',
		method: 'post',
		data: obj,
	})
}

export function downMaterialNew(obj) {
	return request({
		url: '/dist/material/new/download',
		method: 'post',
		data: obj,
	})
}

//批量下载素材
export function batchDownload(obj) {
	return request({
		url: '/dist/material/batch/download',
		method: 'post',
		data: obj,
	})
}

//预览
export function preview(params) {
	return request({
		url: '/dist/material/preview',
		method: 'get',
		params: params,
	})
}

//排序
export function sortMaterial(data) {
	return request({
		url: '/dist/material/sort',
		method: 'put',
		data: data,
	})
}

//查询素材类型
export function queryDic(params) {
	return request({
		url: '/dist/material/type/config',
		method: 'get',
		params: params,
	})
}

export function delObj(id) {
	return request({
		url: '/dist/material/' + id,
		method: 'delete',
	})
}

export function addObj(obj) {
	return request({
		url: '/dist/material',
		method: 'post',
		data: obj,
	})
}

export function putObj(obj) {
	return request({
		url: '/dist/material',
		method: 'put',
		data: obj,
	})
}

//  上传文件
export function materialUploadFile(obj) {
	return request({
		url: '/dist/material/uploadFile',
		method: 'post',
		data: obj,
	})
}
